module.exports = __webpack_public_path__ + "static/img/3.b87962b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5/en/btn1/3.jpg
// module id = 68xg
// module chunks = 0